import { motion } from "framer-motion";
import { LABELS, RADIO_RESIDENCY } from "@/lib/constants";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

// Combined trust list — labels + radio residency, editorial marquee style
export const TrustedBy = () => {
  const items = [
    ...LABELS.map((l) => ({ name: l.name, sub: l.sub })),
    { name: RADIO_RESIDENCY.name, sub: RADIO_RESIDENCY.role },
  ];

  return (
    <section
      data-testid="trusted-by-section"
      className="relative w-full bg-bg py-20 md:py-28 border-t border-[color:var(--line)] overflow-hidden"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <motion.div
          variants={stagger(0.1, 0.05)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mb-10 md:mb-14 text-center"
        >
          <motion.p
            variants={fadeUp}
            className="mb-3 inline-flex items-center gap-3 text-[10px] font-semibold tracking-[0.32em] uppercase text-gold"
          >
            <span className="h-px w-8 bg-[color:var(--gold)]/70" />
            Trust
            <span className="h-px w-8 bg-[color:var(--gold)]/70" />
          </motion.p>
          <motion.h2
            variants={fadeUp}
            data-testid="trusted-by-title"
            className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-ink"
          >
            Official releases &{" "}
            <span className="font-editorial text-gold-hi">radio support</span>
          </motion.h2>
        </motion.div>
      </div>

      {/* Editorial marquee */}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 md:w-48 bg-gradient-to-r from-[#0a0a0a] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 md:w-48 bg-gradient-to-l from-[#0a0a0a] to-transparent" />
        <div className="overflow-hidden py-6 border-y border-[color:var(--line)]">
          <div className="marquee-track inline-flex whitespace-nowrap">
            {[...items, ...items, ...items].map((it, i) => (
              <div
                key={`${it.name}-${i}`}
                className="mx-10 inline-flex items-center gap-6"
                data-testid={`trusted-by-item-${i}`}
              >
                <span className="font-display text-2xl md:text-4xl font-black uppercase tracking-[0.06em] text-ink/85">
                  {it.name}
                </span>
                <span className="font-editorial text-lg text-[color:var(--gold-hi)]/60">
                  · {it.sub} ·
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
